<template>
  <div class="flex flex-col items-center my-4 gap-4 p-4 sm:p-0">
    <slot />
  </div>
</template>

<script setup></script>
